import target from 'images/logos/target.svg';
import theory11 from 'images/logos/theory11.svg';

export default { theory11, target };
